export const RESETORIGINALPWD_INIT_ACTION = "RESETORIGINALPWD_INIT";
export const RESETORIGINALPWD_FAIL_ACTION = RESETORIGINALPWD_INIT_ACTION + "_ERROR";
export const RESETORIGINALPWD_SUCCESS_ACTION = RESETORIGINALPWD_INIT_ACTION + "_SUCCESS";

export function resetOriginalPwd(value) {
  return {
    type: RESETORIGINALPWD_INIT_ACTION,
    value: value,
  };
}